import { GlobalComponent } from '../../../shared/global';
import { Group } from '../../../api/api-checkout/models/rq-checkout-search';

export const getSegmentsIndexes = (
  segments: number[],
  group: Group = GlobalComponent.appGroupSeleted
): number[] => {
  if (!group || !group.departure?.length) return [];

  const indexes: number[] = [];

  if (group.departure.length > 1)
    group.departure.forEach((dep) => {
      indexes.push(dep.segments[0]?.segmentId ?? -1);
    });
  else {
    const indexDep = group.departure[0].segments.findIndex((seg) => seg.segmentId == segments[0]);
    indexes.push(indexDep);
  }

  if (group.returns?.segments?.length) {
    const indexRet = group.returns.segments.findIndex((seg) => seg.segmentId == segments[1]);
    indexes.push(indexRet);
  }

  return indexes;
};
